import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-valid8-page',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './valid8-page.component.html',
  styleUrl: './valid8-page.component.scss',
})
export class Valid8PageComponent {}
